/**
 * Avis Price Bridge — DEBUG VERSION
 * Logs every step so you can see exactly what happens in the console.
 *
 * After confirming it works, set DEBUG = false to silence logs.
 */

(function () {
  'use strict';

  var DEBUG = true;
  function log() { if (DEBUG) console.log.apply(console, arguments); }
  function warn() { console.warn.apply(console, arguments); }

  log('[avis-bridge] ═══ script loaded ═══');

  // ── Wait for theme runtime ────────────────────────────────────
  function whenReady(fn) {
    log('[avis-bridge] checking theme availability…');
    if (typeof theme !== 'undefined' && theme.Currency && theme.pubsub) {
      log('[avis-bridge] theme already ready ✓');
      fn();
      return;
    }
    log('[avis-bridge] theme NOT ready, polling…');
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var ok = typeof theme !== 'undefined' && theme.Currency && theme.pubsub;
      if (ok) {
        log('[avis-bridge] theme ready after', tries * 100, 'ms ✓');
        clearInterval(t);
        fn();
      } else if (tries > 60) {
        warn('[avis-bridge] ✗ gave up waiting for theme after 6s');
        clearInterval(t);
      }
    }, 100);
  }

  whenReady(main);

  // ═══════════════════════════════════════════════════════════════
  //  MAIN
  // ═══════════════════════════════════════════════════════════════

  function main() {
    log('[avis-bridge] main() — looking for #avpoptions-container__v2');
    waitForAvis(function (avisContainer) {
      log('[avis-bridge] Avis container found ✓');
      var bridge = new AvisPriceBridge(avisContainer);
      bridge.init();
      window.__avisPriceBridge = bridge;
      log('[avis-bridge] bridge ready.  window.__avisPriceBridge available');
      log('[avis-bridge] initialised:', bridge.initialised);
      log('[avis-bridge] basePrice:', bridge.basePrice);
    });
  }

  function waitForAvis(cb) {
    function check() {
      var el = document.getElementById('avpoptions-container__v2');
      if (el) { cb(el); return true; }
      return false;
    }
    if (check()) return;
    log('[avis-bridge] Avis container NOT in DOM yet, polling…');
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (check()) {
        log('[avis-bridge] Avis container appeared after', tries * 250, 'ms ✓');
        clearInterval(t);
      } else if (tries > 40) {
        warn('[avis-bridge] ✗ gave up waiting for Avis container after 10s');
        clearInterval(t);
      }
    }, 250);
  }

  // ═══════════════════════════════════════════════════════════════
  //  AvisPriceBridge
  // ═══════════════════════════════════════════════════════════════

  function AvisPriceBridge(avisEl) {
    this.avis = avisEl;
    this.basePrice = 0;
    this.initialised = false;

    this._onChange = null;
    this._onClick = null;
    this._observer = null;
    this._variantUnsub = null;
    this._debounce = null;
  }

  AvisPriceBridge.prototype.init = function () {
    if (this.initialised) { log('[avis-bridge] init — already initialised, skipping'); return; }

    this.buyPrice = document.querySelector('product-buy-price');
    log('[avis-bridge] init — product-buy-price found:', !!this.buyPrice);
    if (this.buyPrice) {
      log('[avis-bridge]   data-price attr:', this.buyPrice.getAttribute('data-price'));
    }

    this._readBasePrice();
    log('[avis-bridge] init — basePrice =', this.basePrice, 'cents (', (this.basePrice/100).toFixed(2), '€)');

    // Dump Avis checkbox status
    this._dumpAvisState();

    this._bindDocumentEvents();
    log('[avis-bridge] init — document events bound ✓');

    this._bindObserver();
    log('[avis-bridge] init — MutationObserver bound ✓');

    this._bindVariantChange();
    log('[avis-bridge] init — variantChange subscriber bound ✓');

    this.initialised = true;
  };

  AvisPriceBridge.prototype._dumpAvisState = function () {
    if (!this.avis) return;
    var allCbs = this.avis.querySelectorAll('input.avp-productoptiontextcolor[type="checkbox"]');
    log('[avis-bridge] Avis checkboxes found:', allCbs.length);
    for (var i = 0; i < allCbs.length; i++) {
      var cb = allCbs[i];
      log('[avis-bridge]   [' + i + '] name="' + cb.getAttribute('name') + '"',
          'checked:', cb.checked,
          'data-variant-price:', cb.getAttribute('data-variant-price'));
    }
    // Also check for quantity inputs
    var qtyInputs = this.avis.querySelectorAll('.avp-qty-input');
    log('[avis-bridge] Avis quantity inputs found:', qtyInputs.length);
    // Check the total display
    var totalEl = document.getElementById('avp-productoption-totalpriceadd');
    if (totalEl) log('[avis-bridge] Avis total display text:', totalEl.textContent);
  };

  AvisPriceBridge.prototype.teardown = function () {
    log('[avis-bridge] teardown');
    if (this._onChange) {
      document.removeEventListener('change', this._onChange, true);
      this._onChange = null;
    }
    if (this._onClick) {
      document.removeEventListener('click', this._onClick, true);
      this._onClick = null;
    }
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this._variantUnsub) {
      this._variantUnsub();
      this._variantUnsub = null;
    }
    if (this._debounce) {
      clearTimeout(this._debounce);
      this._debounce = null;
    }
    this.initialised = false;
  };

  AvisPriceBridge.prototype.reinit = function () {
    log('[avis-bridge] reinit — variant changed, tearing down & reinitialising');
    var self = this;
    this.teardown();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(function () {
          self.buyPrice = document.querySelector('product-buy-price');
          self._readBasePrice();
          self.init();
          self._recalculate();
        }, 250);
      });
    });
  };

  // ── Base price ───────────────────────────────────────────────

  AvisPriceBridge.prototype._readBasePrice = function () {
    var bp = this.buyPrice || document.querySelector('product-buy-price');
    this.buyPrice = bp;
    if (bp) {
      var raw = parseInt(bp.getAttribute('data-price'), 10);
      if (!isNaN(raw)) { this.basePrice = raw; log('[avis-bridge] readBasePrice from product-buy-price:', raw); return; }
    }
    var jsonEl = document.querySelector('variant-selects [data-selected-variant]');
    if (jsonEl) {
      try {
        var v = JSON.parse(jsonEl.textContent);
        if (v && typeof v.price === 'number') { this.basePrice = v.price; log('[avis-bridge] readBasePrice from variant JSON:', v.price); return; }
      } catch (_) { warn('[avis-bridge] failed to parse variant JSON'); }
    }
    warn('[avis-bridge] ✗ could not read base price, defaulting to 0');
    this.basePrice = 0;
  };

  // ── Addon total ──────────────────────────────────────────────

  AvisPriceBridge.prototype._getAddonTotal = function () {
    if (!this.avis) return 0;
    var total = 0;
    var cbs = this.avis.querySelectorAll(
      'input.avp-productoptiontextcolor[type="checkbox"]:checked'
    );
    for (var i = 0; i < cbs.length; i++) {
      var cb = cbs[i];
      var price = parseInt(cb.getAttribute('data-variant-price'), 10);
      if (isNaN(price)) continue;
      var qty = 1;
      var grid = cb.closest('.avp-value-grid');
      if (grid) {
        var qi = grid.querySelector('.avp-qty-input');
        if (qi) {
          var v = parseInt(qi.value, 10);
          if (!isNaN(v) && v > 0) qty = v;
        }
      }
      total += price * qty;
    }
    return total;
  };

  // ── Recalculate & update ─────────────────────────────────────

  AvisPriceBridge.prototype._recalculate = function () {
    var addon = this._getAddonTotal();
    var combined = this.basePrice + addon;

    log('[avis-bridge] ★ RECALC — base:', this.basePrice,
        'addon:', addon,
        '→ combined:', combined,
        '(' + (combined/100).toFixed(2) + '€)');

    var fmt = theme.settings.currencyCodeEnabled
      ? theme.settings.moneyWithCurrencyFormat
      : theme.settings.moneyFormat;
    var html = theme.Currency.formatMoney(combined, fmt);
    log('[avis-bridge]   formatted HTML:', html);

    this._updateBuyButton(combined, html);
    this._updateMainPrice(html);
    this._updateStickyPrice(html);
  };

  AvisPriceBridge.prototype._updateBuyButton = function (cents, html) {
    // Try multiple strategies — there may be >1 product-buy-price on the page
    var found = false;

    // Strategy 1: use cached reference if still in DOM
    if (this.buyPrice && this.buyPrice.isConnected) {
      this.buyPrice.setAttribute('data-price', cents);
      this.buyPrice.innerHTML = html;
      found = true;
      log('[avis-bridge]   ✓ BuyButtonPrice updated (cached ref)');
    }

    // Strategy 2: query by custom element tag name (may return multiple)
    var all = document.querySelectorAll('product-buy-price');
    log('[avis-bridge]   product-buy-price elements found:', all.length);
    for (var i = 0; i < all.length; i++) {
      var bp = all[i];
      // Skip if already updated via cached ref
      if (bp === this.buyPrice && found) continue;
      // Only update elements that are visible (inside the current form)
      log('[avis-bridge]     [' + i + '] form:', bp.getAttribute('form'), ' isConnected:', bp.isConnected);
      bp.setAttribute('data-price', cents);
      bp.innerHTML = html;
      if (!found) { this.buyPrice = bp; }
      found = true;
      log('[avis-bridge]     [' + i + '] ✓ updated');
    }

    // Strategy 3: query by ID pattern as fallback
    if (!found) {
      var container = document.querySelector('[id^="BuyButtonPrice-"]');
      if (container) {
        var bp2 = container.querySelector('product-buy-price');
        if (bp2) {
          bp2.setAttribute('data-price', cents);
          bp2.innerHTML = html;
          this.buyPrice = bp2;
          found = true;
          log('[avis-bridge]   ✓ BuyButtonPrice updated (via ID fallback)');
        }
      }
    }

    if (!found) {
      warn('[avis-bridge] ✗ updateBuyButton — no product-buy-price found (checked tag, cached ref, ID fallback)');
    }
  };

  AvisPriceBridge.prototype._updateMainPrice = function (html) {
    var pw = document.querySelector('[id^="Price-"]');
    if (!pw) { log('[avis-bridge]   — main Price element not found, skipped'); return; }
    if (pw.querySelector('price-per-item')) { log('[avis-bridge]   — volume pricing active, skipped main price'); return; }
    var reg = pw.querySelector('.price__regular');
    if (reg) {
      reg.innerHTML = html;
      log('[avis-bridge]   ✓ Price updated');
    } else {
      log('[avis-bridge]   — .price__regular not found inside Price');
    }
  };

  AvisPriceBridge.prototype._updateStickyPrice = function (html) {
    var sp = document.querySelector('[id^="StickyPrice-"]');
    if (!sp) { log('[avis-bridge]   — StickyPrice not found, skipped'); return; }
    if (sp.querySelector('price-per-item')) { log('[avis-bridge]   — volume pricing in sticky, skipped'); return; }
    var reg = sp.querySelector('.price__regular');
    if (reg) {
      reg.innerHTML = html;
      log('[avis-bridge]   ✓ StickyPrice updated');
    } else {
      log('[avis-bridge]   — .price__regular not found inside StickyPrice');
    }
  };

  // ── Document-level event delegation ──────────────────────────

  AvisPriceBridge.prototype._bindDocumentEvents = function () {
    var self = this;

    this._onChange = function (e) {
      var t = e.target;
      if (!t || !t.matches) return;

      var isAvisCb = t.matches('input.avp-productoptiontextcolor[type="checkbox"]');
      var isAvisQty = t.matches('.avp-qty-input');

      if (isAvisCb || isAvisQty) {
        log('[avis-bridge] ▲ change event captured —',
            isAvisCb ? 'CHECKBOX' : 'QTY-INPUT',
            '| name:', t.getAttribute('name') || t.name,
            '| checked:', t.checked,
            '| value:', t.value);
        self._scheduleRecalc();
      }
    };
    document.addEventListener('change', this._onChange, true);
    log('[avis-bridge]   change listener on document (capture) ✓');

    this._onClick = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Always log clicks to help debug
      var qtyBtn = t.closest('.avp-qty-button');
      var optionWrap = t.closest('.avp-productoptioncheckwrapper');

      if (qtyBtn) {
        log('[avis-bridge] ▲ click on qty button');
        self._scheduleRecalc(120);
        return;
      }
      if (optionWrap) {
        log('[avis-bridge] ▲ click on option wrapper');
        self._scheduleRecalc(120);
        return;
      }
    };
    document.addEventListener('click', this._onClick, true);
    log('[avis-bridge]   click listener on document (capture) ✓');
  };

  AvisPriceBridge.prototype._scheduleRecalc = function (ms) {
    if (this._debounce) clearTimeout(this._debounce);
    var self = this;
    this._debounce = setTimeout(function () {
      self._recalculate();
      self._debounce = null;
    }, ms || 60);
  };

  // ── MutationObserver ─────────────────────────────────────────

  AvisPriceBridge.prototype._bindObserver = function () {
    if (!this.avis) return;
    var self = this;

    this._observer = new MutationObserver(function (mutations) {
      log('[avis-bridge] ▲ mutation detected —', mutations.length, 'mutation(s)');
      self._scheduleRecalc(80);
    });

    this._observer.observe(this.avis, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['checked', 'value'],
      characterData: true
    });
    log('[avis-bridge]   MutationObserver active on Avis container ✓');
  };

  // ── Variant change ───────────────────────────────────────────

  AvisPriceBridge.prototype._bindVariantChange = function () {
    var self = this;
    this._variantUnsub = theme.pubsub.subscribe(
      theme.pubsub.PUB_SUB_EVENTS.variantChange,
      function (event) {
        if (!event || !event.data || !event.data.variant) return;
        log('[avis-bridge] ▲ variantChange event — new price:', event.data.variant.price,
            '(' + (event.data.variant.price/100).toFixed(2) + '€)');
        self.basePrice = event.data.variant.price;
        self.reinit();
      }
    );
    log('[avis-bridge]   variantChange subscriber active ✓');
  };

})();
